
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    selector: 'shared-observable-base',
    imports: [],
    template: ``,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ObservableBaseComponent implements OnDestroy {

  hasServerErr: boolean = false;

  private _unsubscribe$: Subject<void> = new Subject<void>();
  get unsubscribe$() { return this._unsubscribe$; }

  private readonly _isBusy: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isBusy$ = this._isBusy.asObservable();
  set isBusy(isBusy: boolean) {
    this._isBusy.next(isBusy);
  }
  get isBusy() {
    return this._isBusy.getValue();
  }

  private readonly _isLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLoaded$ = this._isLoaded.asObservable();
  set isLoaded(isLoaded: boolean) {
    this._isLoaded.next(isLoaded);
  }
  get isLoaded() {
    return this._isLoaded.getValue();
  }

  private readonly _errors: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  errors$ = this._errors.asObservable();
  set errors(errors: string[]) {
    this._errors.next(errors);
  }
  get errors() {
    return this._errors.getValue();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this._isBusy.next(false);
    this._isBusy.complete();
  }

}
